module.exports = __webpack_public_path__ + "img/EU.93555e17.svg";